import React from "react";

const NoMatch = () => {
  return <h1 id="not-found">404 - Page NOT Found</h1>;
};

export default NoMatch;
